<script lang="typescript">
    import { fade } from "svelte/transition";
    import { state, setState } from "./stores.js";
    import { MessageType } from "./types";
    import { getAvailableBaseLensKeys, getBaseLensObject } from "./utils";
    import { lensTierNames, upgradeLensTierNames } from "./appData.js";
    export let disabled = false;
    export let showUpgradeTiers: boolean = false;

    const baseLensKeys = getAvailableBaseLensKeys($state.focalType, $state.readingAdd, $state.rxId);
    const lensObject = getBaseLensObject($state.focalType);

    let currentLensTierNames = lensTierNames;
    let currentLensKeys = baseLensKeys;

    if (showUpgradeTiers) {
        const upgradeLensKeys = lensObject[$state.upgradeLensKey].upgradeLensCodes;
        // combine the base lens keys and the upgrade lens keys
        currentLensKeys = [$state.upgradeLensKey, ...upgradeLensKeys];
        const previousLensTier = baseLensKeys.indexOf($state.upgradeLensKey);
        currentLensTierNames = [...upgradeLensTierNames];
        currentLensTierNames[0] = lensTierNames[previousLensTier];
    }

    const setLensTier = (lensTier) => {
        let code = currentLensKeys[lensTier];
        setState({
            message: MessageType.SET_BASE_LENS,
            baseLensKey: currentLensKeys[lensTier],
            lensTier,
        });
    };
</script>

<nav class="flex justify-center w-screen space-x-2 shadow-md" in:fade>
    {#each currentLensTierNames as opt, i}
        <button
            class={i === $state.lensTier ? "btn-active" : "btn"}
            type="button"
            on:click={() => setLensTier(i)}
            {disabled}
        >
            {opt}
        </button>
    {/each}
</nav>

<style>
    button {
        @apply text-xl border-0 px-8 py-2 my-6;
        @apply hover:shadow-none;
    }

    .btn-active {
        @apply font-bold border-primary border-b-4;
    }

    .btn {
        @apply font-light;
    }

    button:hover,
    button:focus,
    button:active {
        @apply bg-white shadow-none active:shadow-none focus:shadow-none;
    }
</style>
